import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {
  apiMethods,
  apiEndPoints,
  IncomeSlipsFormsId,
  slipType,
} from '@constants/index';
import { Observable } from 'rxjs';
import { ISlipsFormApiResponse } from '@core/models/index';

@Injectable()
export class ItrSlipsService {
  constructor(private readonly http: ApiService) {}

  public submitSlipsFormData(
    postData,
    formId: number
  ): Observable<ISlipsFormApiResponse> {
    const apiEndPoint = `${apiEndPoints.itr}${this.getSlipsFormApiEndPoint(
      formId
    )}`;
    return this.http.invoke({
      method: postData.id ? apiMethods.patch : apiMethods.post,
      path: postData.id ? `${apiEndPoint}/${postData.id}` : `${apiEndPoint}`,
      body: postData,
    });
  }

  public submitRrspFormData(
    postData,
    formId: number
  ): Observable<ISlipsFormApiResponse> {
    const apiEndPoint = `${apiEndPoints.rrsp}${this.getSlipsFormApiEndPoint(
      formId
    )}`;
    return this.http.invoke({
      method: postData.id ? apiMethods.patch : apiMethods.post,
      path: postData.id ? `${apiEndPoint}/${postData.id}` : `${apiEndPoint}`,
      body: postData,
    });
  }

  public submitDeductionFormData(
    postData,
    formId: number
  ): Observable<ISlipsFormApiResponse> {
    const apiEndPoint = `${
      apiEndPoints.deduction
    }${this.getSlipsFormApiEndPoint(formId)}`;
    return this.http.invoke({
      method: postData.id ? apiMethods.patch : apiMethods.post,
      path: postData.id ? `${apiEndPoint}/${postData.id}` : `${apiEndPoint}`,
      body: postData,
    });
  }

  public submitProvincialFormData(
    postData,
    formId: number
  ): Observable<ISlipsFormApiResponse> {
    const apiEndPoint = `${
      apiEndPoints.provincial
    }${this.getSlipsFormApiEndPoint(formId)}`;
    return this.http.invoke({
      method: postData.id ? apiMethods.patch : apiMethods.post,
      path: postData.id ? `${apiEndPoint}/${postData.id}` : `${apiEndPoint}`,
      body: postData,
    });
  }

  public fetchSlipsFormDetails(
    formId: number,
    formEditId: number
  ): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${this.getSlipsFormApiEndPoint(
        formId
      )}/${formEditId}`,
    });
  }
  public fetchSlipForms(itrId, type): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.slipList}/${itrId}`,
      query: { form_type: type },
    });
  }
  public deleteSlipForm(formId, id): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.delete,
      path: `${apiEndPoints.itr}${this.getSlipsFormApiEndPoint(formId)}/${id}`,
    });
  }
  public getSlipFormMetaData(
    currentSlipType: string
  ): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.slipFormMetaData}`,
      query: { form_type: currentSlipType },
    });
  }

  public getT5013IncomeSources(): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.t5013SlipIncomeSource}`,
    });
  }

  public getAllDataApi(apiName: any): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiName}`,
    });
  }

  public getAllRRSPDataApi(apiName: any): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.rrsp}${apiName}`,
    });
  }

  public getEmploymentStatusData(id: any): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.employeeStatusData}/${id}`,
    });
  }
  public getSelfEmploymentData(id: any): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.selfEmploymentData}/${id}`,
    });
  }
  public getRentalData(id: any): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.rentalData}/${id}`,
    });
  }

  public getFishingData(id: any): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.fishingData}/${id}`,
    });
  }

  public getEmploymentExpensesData(id: any): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.employmentExpensesData}/${id}`,
    });
  }

  public getFarmingData(id: any): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.farmingData}/${id}`,
    });
  }

  public getInvestmentExpensesData(id: any): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.investmentExpenseData}/${id}`,
    });
  }

  public getTaxOnSplitIncomeData(id: any): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.taxOnSplitIncomeData}/${id}`,
    });
  }

  public getAllSectionItrData(
    apiName: any,
    id: any
  ): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.rrsp}${apiName}/${id}`,
    });
  }

  public getEditValues(
    apiName: any,
    id: any
  ): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiName}/${id}`,
    });
  }

  public getRrspEditValues(
    apiName: any,
    id: any
  ): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.rrsp}${apiName}/${id}`,
    });
  }

  public getDeductionEditValues(
    apiName: any,
    id: any
  ): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.deduction}${apiName}/${id}`,
    });
  }

  public getprovincialEditValues(
    apiName: any,
    id: any
  ): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.provincial}${apiName}/${id}`,
    });
  }

  private getSlipsFormApiEndPoint(formId): string {
    let apiEndPoint = ``;
    switch (formId) {
      case IncomeSlipsFormsId.t3TrustIncomeTax:
        apiEndPoint = `${apiEndPoints.t3TrustIncomeTax}`;
        break;
      case IncomeSlipsFormsId.t4RifTax:
        apiEndPoint = `${apiEndPoints.t4RifTax}`;
        break;
      case IncomeSlipsFormsId.t4APension:
        apiEndPoint = `${apiEndPoints.t4APension}`;
        break;
      case IncomeSlipsFormsId.t4PsIncome:
        apiEndPoint = `${apiEndPoints.t4PsIncome}`;
        break;
      case IncomeSlipsFormsId.t4RspIncome:
        apiEndPoint = `${apiEndPoints.t4RspIncome}`;
        break;
      case IncomeSlipsFormsId.t5Investment:
        apiEndPoint = `${apiEndPoints.t5Investment}`;
        break;
      case IncomeSlipsFormsId.t5008Securities:
        apiEndPoint = `${apiEndPoints.t5008Securities}`;
        break;
      case IncomeSlipsFormsId.t4aOasSecurity:
        apiEndPoint = `${apiEndPoints.t4AOasSecurities}`;
        break;
      case IncomeSlipsFormsId.t4eBenefits:
        apiEndPoint = `${apiEndPoints.t4eBenefits}`;
        break;
      case IncomeSlipsFormsId.t5007Benefits:
        apiEndPoint = `${apiEndPoints.t5007Benefits}`;
        break;
      case IncomeSlipsFormsId.rc62UCCB:
        apiEndPoint = `${apiEndPoints.rc62UCCB}`;
        break;
      case IncomeSlipsFormsId.rc210Cwb:
        apiEndPoint = `${apiEndPoints.rc210Cwb}`;
        break;
      case IncomeSlipsFormsId.t4ApCppQpp:
        apiEndPoint = `${apiEndPoints.t4ApCppQppBenefits}`;
        break;
      case IncomeSlipsFormsId.t4Enumeration:
        apiEndPoint = `${apiEndPoints.t4Enumeration}`;
        break;
      case IncomeSlipsFormsId.rrspRetirement:
        apiEndPoint = `${apiEndPoints.retirementSavingForm}`;
        break;
      case IncomeSlipsFormsId.t2202Tuition:
        apiEndPoint = `${apiEndPoints.t2202Tuition}`;
        break;
      case IncomeSlipsFormsId.medicalSlip:
        apiEndPoint = `${apiEndPoints.medicalSlip}`;
        break;
      case IncomeSlipsFormsId.donationSlip:
        apiEndPoint = `${apiEndPoints.donationSlip}`;
        break;
      case IncomeSlipsFormsId.t101Slip:
        apiEndPoint = `${apiEndPoints.t101Slip}`;
        break;
      case IncomeSlipsFormsId.t5013Slip:
        apiEndPoint = `${apiEndPoints.t5013Slip}`;
        break;
      case IncomeSlipsFormsId.t4arcaArrangement:
        apiEndPoint = `${apiEndPoints.t4arcaArrangement}`;
        break;
      case IncomeSlipsFormsId.T5006RegisteredLabour:
        apiEndPoint = `${apiEndPoints.T5006RegisteredLabour}`;
        break;
      case IncomeSlipsFormsId.foreignIncome:
        apiEndPoint = `${apiEndPoints.foreignIncome}`;
        break;
      case IncomeSlipsFormsId.t10PensionAdjustment:
        apiEndPoint = `${apiEndPoints.t10PensionAdjustment}`;
        break;
      case IncomeSlipsFormsId.otherEmploymentIncome:
        apiEndPoint = `${apiEndPoints.otherEmploymentIncome}`;
        break;
      case IncomeSlipsFormsId.clergyResidenceDeduction:
        apiEndPoint = `${apiEndPoints.clergyResidenceDeduction}`;
        break;
      case IncomeSlipsFormsId.clergyResidenceDeduction2:
        apiEndPoint = `${apiEndPoints.clergyResidenceDeduction2}`;
        break;
      case IncomeSlipsFormsId.wageLossReplacement:
        apiEndPoint = `${apiEndPoints.wageLossReplacement}`;
        break;
      case IncomeSlipsFormsId.transportEmployee:
        apiEndPoint = `${apiEndPoints.transportEmployee}`;
        break;
      case IncomeSlipsFormsId.shortHaul:
        apiEndPoint = `${apiEndPoints.shortHaul}`;
        break;
      case IncomeSlipsFormsId.longHaul:
        apiEndPoint = `${apiEndPoints.longHaul}`;
        break;
      case IncomeSlipsFormsId.repayments:
        apiEndPoint = `${apiEndPoints.repayments}`;
        break;
      case IncomeSlipsFormsId.gstRebate:
        apiEndPoint = `${apiEndPoints.gstRebate}`;
        break;
      case IncomeSlipsFormsId.deferredStock:
        apiEndPoint = `${apiEndPoints.deferredStock}`;
        break;
      case IncomeSlipsFormsId.employeeProfitSharing:
        apiEndPoint = `${apiEndPoints.employeeProfitSharing}`;
        break;
      case IncomeSlipsFormsId.employementExpenses:
        apiEndPoint = `${apiEndPoints.employmentExpenses}`;
        break;
      case IncomeSlipsFormsId.additionalCppQpp:
        apiEndPoint = `${apiEndPoints.additionalCppQpp}`;
        break;
      case IncomeSlipsFormsId.employmentStatusProfile:
        apiEndPoint = `${apiEndPoints.employmentStatusProfile}`;
        break;
      case IncomeSlipsFormsId.businessCategory:
        apiEndPoint = `${apiEndPoints.businessCategory}`;
        break;
      case IncomeSlipsFormsId.t1139Form:
        apiEndPoint = `${apiEndPoints.t1139Form}`;
        break;
      case IncomeSlipsFormsId.selfBusinessIncome:
        apiEndPoint = `${apiEndPoints.selfBusinessIncome}`;
        break;
      case IncomeSlipsFormsId.businessIncome:
        apiEndPoint = `${apiEndPoints.businessIncome}`;
        break;
      case IncomeSlipsFormsId.workBusiness:
        apiEndPoint = `${apiEndPoints.workBusiness}`;
        break;
      case IncomeSlipsFormsId.aboutPartnership:
        apiEndPoint = `${apiEndPoints.aboutPartnership}`;
        break;
      case IncomeSlipsFormsId.partnershipDetails:
        apiEndPoint = `${apiEndPoints.partnershipDetails}`;
        break;
      case IncomeSlipsFormsId.expensesPartnership:
        apiEndPoint = `${apiEndPoints.expensesPartnership}`;
        break;
      case IncomeSlipsFormsId.equityPartnership:
        apiEndPoint = `${apiEndPoints.equityPartnership}`;
        break;
      case IncomeSlipsFormsId.earnedIncomeWebsite:
        apiEndPoint = `${apiEndPoints.earnedIncomeWebsite}`;
        break;
      case IncomeSlipsFormsId.advertising:
        apiEndPoint = `${apiEndPoints.advertising}`;
        break;
      case IncomeSlipsFormsId.entertainment:
        apiEndPoint = `${apiEndPoints.entertainment}`;
        break;
      case IncomeSlipsFormsId.personalVehicleExpenses:
        apiEndPoint = `${apiEndPoints.personalVehicleExpenses}`;
        break;
      case IncomeSlipsFormsId.businessVehicleExpenses:
        apiEndPoint = `${apiEndPoints.businessVehicleExpenses}`;
        break;
      case IncomeSlipsFormsId.wages:
        apiEndPoint = `${apiEndPoints.wages}`;
        break;
      case IncomeSlipsFormsId.businessRelated:
        apiEndPoint = `${apiEndPoints.businessRelated}`;
        break;
      case IncomeSlipsFormsId.doubtfulAccount:
        apiEndPoint = `${apiEndPoints.doubtfulAccount}`;
        break;
      case IncomeSlipsFormsId.licensesTaxes:
        apiEndPoint = `${apiEndPoints.licensesTaxes}`;
        break;
      case IncomeSlipsFormsId.commercialInsurance:
        apiEndPoint = `${apiEndPoints.commercialInsurance}`;
        break;
      case IncomeSlipsFormsId.interestMaintenance:
        apiEndPoint = `${apiEndPoints.interestMaintenance}`;
        break;
      case IncomeSlipsFormsId.officeSupplies:
        apiEndPoint = `${apiEndPoints.officeSupplies}`;
        break;
      case IncomeSlipsFormsId.bankingFeesAdvice:
        apiEndPoint = `${apiEndPoints.bankingFeesAdvice}`;
        break;
      case IncomeSlipsFormsId.taxesRent:
        apiEndPoint = `${apiEndPoints.taxesRent}`;
        break;
      case IncomeSlipsFormsId.utilitiesBusiness:
        apiEndPoint = `${apiEndPoints.utilitiesBusiness}`;
        break;
      case IncomeSlipsFormsId.otherExpenses:
        apiEndPoint = `${apiEndPoints.otherExpenses}`;
        break;
      case IncomeSlipsFormsId.uccBalances:
        apiEndPoint = `${apiEndPoints.uccBalances}`;
        break;
      case IncomeSlipsFormsId.additionDisposition:
        apiEndPoint = `${apiEndPoints.additionDisposition}`;
        break;
      case IncomeSlipsFormsId.homeForWork:
        apiEndPoint = `${apiEndPoints.homeForWork}`;
        break;
      case IncomeSlipsFormsId.homeUseForWork:
        apiEndPoint = `${apiEndPoints.homeUseForWork}`;
        break;
      case IncomeSlipsFormsId.homeYouUseForWork:
        apiEndPoint = `${apiEndPoints.homeYouUseForWork}`;
        break;
      case IncomeSlipsFormsId.homeExpenses:
        apiEndPoint = `${apiEndPoints.homeExpenses}`;
        break;
      case IncomeSlipsFormsId.selfEmploymentRevenue:
        apiEndPoint = `${apiEndPoints.selfEmploymentRevenue}`;
        break;
      case IncomeSlipsFormsId.reservesDeducted:
        apiEndPoint = `${apiEndPoints.reservesDeducted}`;
        break;
      case IncomeSlipsFormsId.sellProductBought:
        apiEndPoint = `${apiEndPoints.sellProductBought}`;
        break;
      case IncomeSlipsFormsId.fishingIncome:
        apiEndPoint = `${apiEndPoints.fishingIncome}`;
        break;
      case IncomeSlipsFormsId.fishingIntro:
        apiEndPoint = `${apiEndPoints.fishingIntro}`;
        break;
      case IncomeSlipsFormsId.otherFishingIncome:
        apiEndPoint = `${apiEndPoints.otherFishingIncome}`;
        break;
      case IncomeSlipsFormsId.fishingExpenses:
        apiEndPoint = `${apiEndPoints.fishingExpenses}`;
        break;
      case IncomeSlipsFormsId.otherFishingExpenses:
        apiEndPoint = `${apiEndPoints.otherFishingExpenses}`;
        break;
      case IncomeSlipsFormsId.otherDeductions:
        apiEndPoint = `${apiEndPoints.otherDeductions}`;
        break;
      case IncomeSlipsFormsId.fishingReconciliationForm:
        apiEndPoint = `${apiEndPoints.fishingReconciliationForm}`;
        break;
      case IncomeSlipsFormsId.fishingHomeForWork:
        apiEndPoint = `${apiEndPoints.fishingHomeForWork}`;
        break;
      case IncomeSlipsFormsId.farmingIntro:
        apiEndPoint = `${apiEndPoints.farmingIntro}`;
        break;
      case IncomeSlipsFormsId.farmingIncome:
        apiEndPoint = `${apiEndPoints.farmingIncome}`;
        break;
      case IncomeSlipsFormsId.otherFarmingIncome:
        apiEndPoint = `${apiEndPoints.otherFarmingIncome}`;
        break;
      case IncomeSlipsFormsId.farmingLiveStockSold:
        apiEndPoint = `${apiEndPoints.farmingLiveStockSold}`;
        break;
      case IncomeSlipsFormsId.farmingProgramPayment:
        apiEndPoint = `${apiEndPoints.farmingProgramPayment}`;
        break;
      case IncomeSlipsFormsId.farmingExpenses:
        apiEndPoint = `${apiEndPoints.farmingExpenses}`;
        break;
      case IncomeSlipsFormsId.farmingProgramOverpayment:
        apiEndPoint = `${apiEndPoints.farmingProgramOverpayment}`;
        break;
      case IncomeSlipsFormsId.farmingExpensesLiveStock:
        apiEndPoint = `${apiEndPoints.farmingExpensesLiveStock}`;
        break;
      case IncomeSlipsFormsId.otherFarmingExpenses:
        apiEndPoint = `${apiEndPoints.otherFarmingExpenses}`;
        break;
      case IncomeSlipsFormsId.otherFarmingDeduction:
        apiEndPoint = `${apiEndPoints.otherFarmingDeduction}`;
        break;
      case IncomeSlipsFormsId.quotaAdditionDisposition:
        apiEndPoint = `${apiEndPoints.quotaAdditionDisposition}`;
        break;
      case IncomeSlipsFormsId.inventoryAdjustment:
        apiEndPoint = `${apiEndPoints.inventoryAdjustment}`;
        break;
      case IncomeSlipsFormsId.farmingReconciliationForm:
        apiEndPoint = `${apiEndPoints.farmingReconciliationForm}`;
        break;
      case IncomeSlipsFormsId.agriStabilityInvestIntro:
        apiEndPoint = `${apiEndPoints.agriStabilityInvestIntro}`;
        break;
      case IncomeSlipsFormsId.agriStabilityInvestIncome:
        apiEndPoint = `${apiEndPoints.agriStabilityInvestIncome}`;
        break;
      case IncomeSlipsFormsId.agriStabilityInvestExpenses:
        apiEndPoint = `${apiEndPoints.agriStabilityInvestExpenses}`;
        break;
      case IncomeSlipsFormsId.investmentExpenseData:
        apiEndPoint = `${apiEndPoints.investmentExpenseData}`;
        break;
      case IncomeSlipsFormsId.investmentExpensesIntro:
        apiEndPoint = `${apiEndPoints.investmentExpensesIntro}`;
        break;
      case IncomeSlipsFormsId.agriStabilityOtherDeductions:
        apiEndPoint = `${apiEndPoints.agriStabilityOtherDeductions}`;
        break;
      case IncomeSlipsFormsId.investmentExpensesIntro:
        apiEndPoint = `${apiEndPoints.investmentExpensesIntro}`;
        break;
      case IncomeSlipsFormsId.interestExpenses:
        apiEndPoint = `${apiEndPoints.interestExpenses}`;
        break;
      case IncomeSlipsFormsId.carryingCharges:
        apiEndPoint = `${apiEndPoints.carryingCharges}`;
        break;
      case IncomeSlipsFormsId.taxOnSplitIncomeIntro:
        apiEndPoint = `${apiEndPoints.taxOnSplitIncomeIntro}`;
        break;
      case IncomeSlipsFormsId.taxOnSplitIncome:
        apiEndPoint = `${apiEndPoints.taxOnSplitIncome}`;
        break;
      case IncomeSlipsFormsId.taxAdjustedIncome:
        apiEndPoint = `${apiEndPoints.taxAdjustedIncome}`;
        break;
      case IncomeSlipsFormsId.rentalPropertyIntro:
        apiEndPoint = `${apiEndPoints.rentalPropertyIntro}`;
        break;
      case IncomeSlipsFormsId.rentalIncome:
        apiEndPoint = `${apiEndPoints.rentalIncome}`;
        break;
      case IncomeSlipsFormsId.rentalExpenses:
        apiEndPoint = `${apiEndPoints.rentalExpenses}`;
        break;
      case IncomeSlipsFormsId.rentalPartnerDetailsStatement:
        apiEndPoint = `${apiEndPoints.rentalPartnerDetailsStatement}`;
        break;
      case IncomeSlipsFormsId.employementExpensesIntro:
        apiEndPoint = `${apiEndPoints.employementExpensesIntro}`;
        break;
      case IncomeSlipsFormsId.employmentExpensesProfile:
        apiEndPoint = `${apiEndPoints.employmentExpensesProfile}`;
        break;
      case IncomeSlipsFormsId.t2200sEmploymentExpense:
        apiEndPoint = `${apiEndPoints.t2200sEmploymentExpense}`;
        break;
      case IncomeSlipsFormsId.gstHstRebate:
        apiEndPoint = `${apiEndPoints.gstHstRebate}`;
        break;
      case IncomeSlipsFormsId.rrspProfile:
        apiEndPoint = `${apiEndPoints.rrspProfile}`;
        break;
      case IncomeSlipsFormsId.rrspDeductionLimit:
        apiEndPoint = `${apiEndPoints.rrspDeductionLimit}`;
        break;
      case IncomeSlipsFormsId.rrspContribution:
        apiEndPoint = `${apiEndPoints.rrspContribution}`;
        break;
      case IncomeSlipsFormsId.foreignRetirementPlanProfile:
        apiEndPoint = `${apiEndPoints.foreignRetirementPlanProfile}`;
        break;
      case IncomeSlipsFormsId.contributionTemporaryAssignment:
        apiEndPoint = `${apiEndPoints.contributionTemporaryAssignment}`;
        break;
      case IncomeSlipsFormsId.contributionComputerCanada:
        apiEndPoint = `${apiEndPoints.contributionComputerCanada}`;
        break;
      case IncomeSlipsFormsId.contributionForeignEmployer:
        apiEndPoint = `${apiEndPoints.contributionForeignEmployer}`;
        break;
      case IncomeSlipsFormsId.unusedRrspDeductionLimit:
        apiEndPoint = `${apiEndPoints.unusedRrspDeductionLimit}`;
        break;
      case IncomeSlipsFormsId.saskatchewanPensionPlan:
        apiEndPoint = `${apiEndPoints.saskatchewanPensionPlan}`;
        break;
      case IncomeSlipsFormsId.pooledRegisteredPensionPlan:
        apiEndPoint = `${apiEndPoints.pooledRegisteredPensionPlan}`;
        break;
      case IncomeSlipsFormsId.homeBuyerPlanProfile:
        apiEndPoint = `${apiEndPoints.homeBuyerPlanProfile}`;
        break;
      case IncomeSlipsFormsId.homeBuyerPlan:
        apiEndPoint = `${apiEndPoints.homeBuyerPlan}`;
        break;
      case IncomeSlipsFormsId.lifelongLearningPlan:
        apiEndPoint = `${apiEndPoints.lifelongLearningPlan}`;
        break;
      case IncomeSlipsFormsId.lifelongLearningProfile:
        apiEndPoint = `${apiEndPoints.lifelongLearningProfile}`;
        break;
      case IncomeSlipsFormsId.transferRrspPrpp:
        apiEndPoint = `${apiEndPoints.transferRrspPrpp}`;
        break;
      case IncomeSlipsFormsId.refundUnusedRrspPrpp:
        apiEndPoint = `${apiEndPoints.refundUnusedRrspPrpp}`;
        break;
      case IncomeSlipsFormsId.amateurAthleteTrust:
        apiEndPoint = `${apiEndPoints.amateurAthleteTrust}`;
        break;
      case IncomeSlipsFormsId.registeredPensionPlan:
        apiEndPoint = `${apiEndPoints.registeredPensionPlan}`;
        break;
      case IncomeSlipsFormsId.rrspCalculator:
        apiEndPoint = `${apiEndPoints.rrspCalculator}`;
        break;
      case IncomeSlipsFormsId.rrspPrppCarryForward:
        apiEndPoint = `${apiEndPoints.rrspPrppCarryForward}`;
        break;
      case IncomeSlipsFormsId.paymentProfile:
        apiEndPoint = `${apiEndPoints.paymentProfile}`;
        break;
      case IncomeSlipsFormsId.donationProfile:
        apiEndPoint = `${apiEndPoints.donationProfile}`;
        break;
      case IncomeSlipsFormsId.charitableDonationCarriedForward:
        apiEndPoint = `${apiEndPoints.charitableDonationCarriedForward}`;
        break;
      case IncomeSlipsFormsId.charitableDonation:
        apiEndPoint = `${apiEndPoints.charitableDonation}`;
        break;
      case IncomeSlipsFormsId.usDonationReceipt:
        apiEndPoint = `${apiEndPoints.usDonationReceipt}`;
        break;
      case IncomeSlipsFormsId.sharesDonation:
        apiEndPoint = `${apiEndPoints.sharesDonation}`;
        break;
      case IncomeSlipsFormsId.unitedState:
        apiEndPoint = `${apiEndPoints.unitedState}`;
        break;
      case IncomeSlipsFormsId.capitalDonation:
        apiEndPoint = `${apiEndPoints.capitalDonation}`;
        break;
      case IncomeSlipsFormsId.culturalEcologicalGift:
        apiEndPoint = `${apiEndPoints.culturalEcologicalGift}`;
        break;
      case IncomeSlipsFormsId.otherDonation:
        apiEndPoint = `${apiEndPoints.otherDonation}`;
        break;
      case IncomeSlipsFormsId.maxiMizingCharitableDonation:
        apiEndPoint = `${apiEndPoints.maxiMizingCharitableDonation}`;
        break;
      case IncomeSlipsFormsId.donationClaimedCarriedForward:
        apiEndPoint = `${apiEndPoints.donationClaimedCarriedForward}`;
        break;
      case IncomeSlipsFormsId.firstTimeHomeBuyer:
        apiEndPoint = `${apiEndPoints.firstTimeHomeBuyer}`;
        break;
      case IncomeSlipsFormsId.repaymentFederalCovid:
        apiEndPoint = `${apiEndPoints.repaymentFederalCovid}`;
        break;
      case IncomeSlipsFormsId.unionProfessionalMember:
        apiEndPoint = `${apiEndPoints.unionProfessionalMember}`;
        break;
      case IncomeSlipsFormsId.digitalNewsSubscription:
        apiEndPoint = `${apiEndPoints.digitalNewsSubscription}`;
        break;
      case IncomeSlipsFormsId.politicalContribution:
        apiEndPoint = `${apiEndPoints.politicalContribution}`;
        break;
      case IncomeSlipsFormsId.paidTaxInstalment:
        apiEndPoint = `${apiEndPoints.paidTaxInstalment}`;
        break;
      case IncomeSlipsFormsId.foreignTaxCredits:
        apiEndPoint = `${apiEndPoints.foreignTaxCredits}`;
        break;
      case IncomeSlipsFormsId.homeAccessibilityExpense:
        apiEndPoint = `${apiEndPoints.homeAccessibilityExpense}`;
        break;
      case IncomeSlipsFormsId.disabilitySupportPayment:
        apiEndPoint = `${apiEndPoints.disabilitySupportPayment}`;
        break;
      case IncomeSlipsFormsId.disabilityAmount:
        apiEndPoint = `${apiEndPoints.disabilityAmount}`;
        break;
      case IncomeSlipsFormsId.additionalHomeBuyerPlan:
        apiEndPoint = `${apiEndPoints.additionalHomeBuyerPlan}`;
        break;
      case IncomeSlipsFormsId.additionalLlpWithdrawal:
        apiEndPoint = `${apiEndPoints.additionalLlpWithdrawal}`;
        break;
      case IncomeSlipsFormsId.medicalProfile:
        apiEndPoint = `${apiEndPoints.medicalProfile}`;
        break;
      case IncomeSlipsFormsId.medicalExpense:
        apiEndPoint = `${apiEndPoints.medicalExpense}`;
        break;
      case IncomeSlipsFormsId.medicalExpenseReceipt:
        apiEndPoint = `${apiEndPoints.medicalExpenseReceipt}`;
        break;
      case IncomeSlipsFormsId.privateMedicalPlan:
        apiEndPoint = `${apiEndPoints.privateMedicalPlan}`;
        break;
      case IncomeSlipsFormsId.medicalExpenseClaim:
        apiEndPoint = `${apiEndPoints.medicalExpenseClaim}`;
        break;
      case IncomeSlipsFormsId.reasonOfMoving:
        apiEndPoint = `${apiEndPoints.reasonForMoving}`;
        break;
      case IncomeSlipsFormsId.eligibleIncomeAtNewLocation:
        apiEndPoint = `${apiEndPoints.eligibleIncomeAtNewLocation}`;
        break;
      case IncomeSlipsFormsId.movingProfile:
        apiEndPoint = `${apiEndPoints.movingProfile}`;
        break;
      case IncomeSlipsFormsId.movingProfileCarriedForward:
        apiEndPoint = `${apiEndPoints.movingProfileCarriedForward}`;
        break;
      case IncomeSlipsFormsId.howFarDidYouMoved:
        apiEndPoint = `${apiEndPoints.farDidYouMove}`;
        break;
      case IncomeSlipsFormsId.saleYourOldHouse:
        apiEndPoint = `${apiEndPoints.saleOfYourOldHome}`;
        break;
      case IncomeSlipsFormsId.detailsOfTheMove:
        apiEndPoint = `${apiEndPoints.detailOfTheMove}`;
        break;
      case IncomeSlipsFormsId.allowableMovingExpense:
        apiEndPoint = `${apiEndPoints.allowableMovingExpense}`;
        break;
      case IncomeSlipsFormsId.newHomeExpense:
        apiEndPoint = `${apiEndPoints.newHomeExpense}`;
        break;
      case IncomeSlipsFormsId.movingProfileCarriedForward:
        apiEndPoint = `${apiEndPoints.movingProfileCarriedForward}`;
        break;
      case IncomeSlipsFormsId.howFarDidYouMoved:
        apiEndPoint = `${apiEndPoints.farDidYouMove}`;
        break;
      case IncomeSlipsFormsId.saleYourOldHouse:
        apiEndPoint = `${apiEndPoints.saleOfYourOldHome}`;
        break;
      case IncomeSlipsFormsId.detailsOfTheMove:
        apiEndPoint = `${apiEndPoints.detailOfTheMove}`;
        break;
      case IncomeSlipsFormsId.allowableMovingExpense:
        apiEndPoint = `${apiEndPoints.allowableMovingExpense}`;
        break;
      case IncomeSlipsFormsId.newHomeExpense:
        apiEndPoint = `${apiEndPoints.newHomeExpense}`;
        break;
      case IncomeSlipsFormsId.studentProfile:
        apiEndPoint = `${apiEndPoints.studentProfile}`;
        break;
      case IncomeSlipsFormsId.taxBreakGoingSchool:
        apiEndPoint = `${apiEndPoints.taxBreakGoingSchool}`;
        break;
      case IncomeSlipsFormsId.unusedTuitionEducation:
        apiEndPoint = `${apiEndPoints.unusedTuitionEducation}`;
        break;
      case IncomeSlipsFormsId.studentLoanInterestProfile:
        apiEndPoint = `${apiEndPoints.studentLoanInterestProfile}`;
        break;
      case IncomeSlipsFormsId.studentLoanInterest:
        apiEndPoint = `${apiEndPoints.studentLoanInterest}`;
        break;
      case IncomeSlipsFormsId.researchGrantExpense:
        apiEndPoint = `${apiEndPoints.researchGrantExpense}`;
        break;
      case IncomeSlipsFormsId.eligibleReceiveCanadaTraining:
        apiEndPoint = `${apiEndPoints.eligibleReceiveCanadaTraining}`;
        break;
      case IncomeSlipsFormsId.totalCreditReceiving:
        apiEndPoint = `${apiEndPoints.totalCreditReceiving}`;
        break;
      case IncomeSlipsFormsId.employmentRelatedDriving:
        apiEndPoint = `${apiEndPoints.employmentRelatedDriving}`;
        break;
      case IncomeSlipsFormsId.otherEmploymentExpenses:
        apiEndPoint = `${apiEndPoints.otherEmploymentExpenses}`;
        break;
      case IncomeSlipsFormsId.workSpaceHomeExpense:
        apiEndPoint = `${apiEndPoints.workSpaceHomeExpense}`;
        break;
      case IncomeSlipsFormsId.eligibleEducatorTaxCredit:
        apiEndPoint = `${apiEndPoints.eligibleEducatorTaxCredit}`;
        break;
      case IncomeSlipsFormsId.northernResidentDeduction:
        apiEndPoint = `${apiEndPoints.northernResidentDeduction}`;
        break;
      case IncomeSlipsFormsId.northernResidentDeductionTrips:
        apiEndPoint = `${apiEndPoints.northernResidentDeductionTrips}`;
        break;
      case IncomeSlipsFormsId.additionalResidencyAmount:
        apiEndPoint = `${apiEndPoints.additionalResidencyAmount}`;
        break;
      case IncomeSlipsFormsId.volunteerFireFighterRescue:
        apiEndPoint = `${apiEndPoints.volunteerFireFighterRescue}`;
        break;
      case IncomeSlipsFormsId.otherDeduct:
        apiEndPoint = `${apiEndPoints.otherDeduct}`;
        break;
      case IncomeSlipsFormsId.additionalDeduction:
        apiEndPoint = `${apiEndPoints.additionalDeduction}`;
        break;
      case IncomeSlipsFormsId.additionalTaxAccumulatedResp:
        apiEndPoint = `${apiEndPoints.additionalTaxAccumulatedResp}`;
        break;
      case IncomeSlipsFormsId.ontarioProvinceProfile:
        apiEndPoint = `${apiEndPoints.ontarioProvinceProfile}`;
        break;
      case IncomeSlipsFormsId.homeownerPropertyTaxGrant:
        apiEndPoint = `${apiEndPoints.homeownerPropertyTaxGrant}`;
        break;
      case IncomeSlipsFormsId.homeSafetyTaxCredit:
        apiEndPoint = `${apiEndPoints.homeSafetyTaxCredit}`;
        break;
      case IncomeSlipsFormsId.addressOfProperty:
        apiEndPoint = `${apiEndPoints.addressOfProperty}`;
        break;
      case IncomeSlipsFormsId.ontarioTrilliumBenefit:
        apiEndPoint = `${apiEndPoints.ontarioTrilliumBenefit}`;
        break;
      case IncomeSlipsFormsId.ontarioSelfEmploymentTaxCredit:
        apiEndPoint = `${apiEndPoints.ontarioSelfEmploymentTaxCredit}`;
        break;
      case IncomeSlipsFormsId.cooperativeEducationTaxCredit:
        apiEndPoint = `${apiEndPoints.cooperativeEducationTaxCredit}`;
        break;
      case IncomeSlipsFormsId.ontarioOpportunitiesFund:
        apiEndPoint = `${apiEndPoints.ontarioOpportunitiesFund}`;
        break;
      case IncomeSlipsFormsId.climateActionIncentive:
        apiEndPoint = `${apiEndPoints.climateActionIncentive}`;
        break;
      case IncomeSlipsFormsId.applyForOntarioTrilliumBenefit:
        apiEndPoint = `${apiEndPoints.applyForOntarioTrilliumBenefit}`;
        break;
      case IncomeSlipsFormsId.lossesProfile:
        apiEndPoint = `${apiEndPoints.lossesProfile}`;
        break;
      case IncomeSlipsFormsId.allowableBusinessInvestmentLoss:
        apiEndPoint = `${apiEndPoints.allowableBusinessInvestmentLoss}`;
        break;
      case IncomeSlipsFormsId.nonCapitalLossesCarryForward:
        apiEndPoint = `${apiEndPoints.nonCapitalLossesCarryForward}`;
        break;
      case IncomeSlipsFormsId.paymentRelatedPrincipal:
        apiEndPoint = `${apiEndPoints.paymentRelatedPrincipal}`;
        break;
      case IncomeSlipsFormsId.nonCapitalLossesBeingClaimed:
        apiEndPoint = `${apiEndPoints.nonCapitalLossesBeingClaimed}`;
        break;
      case IncomeSlipsFormsId.restrictedFarmingLossCarry:
        apiEndPoint = `${apiEndPoints.restrictedFarmingLossCarry}`;
        break;
      case IncomeSlipsFormsId.restrictedFarmingLossClaimed:
        apiEndPoint = `${apiEndPoints.restrictedFarmingLossClaimed}`;
        break;
      case IncomeSlipsFormsId.farmingFishingLossCarryForward:
        apiEndPoint = `${apiEndPoints.farmingFishingLossCarryForward}`;
        break;
      case IncomeSlipsFormsId.farmingFishingLossCarryClaimed:
        apiEndPoint = `${apiEndPoints.farmingFishingLossCarryClaimed}`;
        break;
      case IncomeSlipsFormsId.personalPropertyLossCarryForward:
        apiEndPoint = `${apiEndPoints.personalPropertyLossCarryForward}`;
        break;
      case IncomeSlipsFormsId.listedPersonalPropertyLoss:
        apiEndPoint = `${apiEndPoints.listedPersonalPropertyLoss}`;
        break;
      case IncomeSlipsFormsId.limitedPartnershipLoss:
        apiEndPoint = `${apiEndPoints.limitedPartnershipLoss}`;
        break;
      case IncomeSlipsFormsId.netCapitalLossCarryForward:
        apiEndPoint = `${apiEndPoints.netCapitalLossCarryForward}`;
        break;
      case IncomeSlipsFormsId.netCapitalLossClaimedForward:
        apiEndPoint = `${apiEndPoints.netCapitalLossClaimedForward}`;
        break;
      case IncomeSlipsFormsId.nonCapitalLossCarrybacks:
        apiEndPoint = `${apiEndPoints.nonCapitalLossCarrybacks}`;
        break;
      case IncomeSlipsFormsId.farmingFishingLossCarrybacks:
        apiEndPoint = `${apiEndPoints.farmingFishingLossCarrybacks}`;
        break;
      case IncomeSlipsFormsId.netCapitalLossCarrybacks:
        apiEndPoint = `${apiEndPoints.netCapitalLossCarrybacks}`;
        break;
      case IncomeSlipsFormsId.lppLossCarrybacks:
        apiEndPoint = `${apiEndPoints.lppLossCarrybacks}`;
        break;
      case IncomeSlipsFormsId.restrictedFarmLossCarrybacks:
        apiEndPoint = `${apiEndPoints.restrictedFarmLossCarrybacks}`;
        break;
      case IncomeSlipsFormsId.lossesProfileSummary:
        apiEndPoint = `${apiEndPoints.lossesProfileSummary}`;
        break;
      case IncomeSlipsFormsId.albertaTaxCreditProfile:
        apiEndPoint = `${apiEndPoints.albertaTaxCreditProfile}`;
        break;
      case IncomeSlipsFormsId.stockSavingsPlanTaxCredit:
        apiEndPoint = `${apiEndPoints.stockSavingsPlanTaxCredit}`;
        break;
      case IncomeSlipsFormsId.investorTaxCredit:
        apiEndPoint = `${apiEndPoints.investorTaxCredit}`;
        break;
      case IncomeSlipsFormsId.britishColumbiaTaxCredit:
        apiEndPoint = `${apiEndPoints.britishColumbiaTaxCredit}`;
        break;
      case IncomeSlipsFormsId.bcSalesTaxCredit:
        apiEndPoint = `${apiEndPoints.bcSalesTaxCredit}`;
        break;
      case IncomeSlipsFormsId.homeRenovationTaxCredit:
        apiEndPoint = `${apiEndPoints.homeRenovationTaxCredit}`;
        break;
      case IncomeSlipsFormsId.trainingTaxCreditIndividual:
        apiEndPoint = `${apiEndPoints.trainingTaxCreditIndividual}`;
        break;
      case IncomeSlipsFormsId.trainingTaxCreditEmployer:
        apiEndPoint = `${apiEndPoints.trainingTaxCreditEmployer}`;
        break;
      case IncomeSlipsFormsId.trainingTaxCreditShipbuilding:
        apiEndPoint = `${apiEndPoints.trainingTaxCreditShipbuilding}`;
        break;
      case IncomeSlipsFormsId.miningExplorationTaxCredit:
        apiEndPoint = `${apiEndPoints.miningExplorationTaxCredit}`;
        break;
      case IncomeSlipsFormsId.miningFlowThroughShareTaxCredit:
        apiEndPoint = `${apiEndPoints.miningFlowThroughShareTaxCredit}`;
        break;
      case IncomeSlipsFormsId.miningFlowThroughShareTaxCreditCarryback:
        apiEndPoint = `${apiEndPoints.miningFlowThroughShareTaxCreditCarryback}`;
        break;
      case IncomeSlipsFormsId.ventureCapital:
        apiEndPoint = `${apiEndPoints.ventureCapital}`;
        break;
      case IncomeSlipsFormsId.carryForwardCapitalGain:
        apiEndPoint = `${apiEndPoints.carryForwardCapitalGain}`;
        break;
      default:
        apiEndPoint = '';
    }
    return apiEndPoint;
  }
}
